module.exports = __webpack_public_path__ + "static/media/g-3-d.1edf8c9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gadgets/g-3-d.jpg
// module id = 1135
// module chunks = 33